<template>
  <button
    v-if="isUserConnected"
    class="btn btn-primary"
    :disabled="isDisabled"
    type="button"
    @click="goToSummary()"
  >
    Sommaire et résultats
  </button>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      return !this.isUserConnected || !this.currentSurveyId
    },
    isUserConnected() {
      return this.$page.props.auth.user
    },
    currentSurvey() {
      return this.$page.props.survey
    },
    currentSurveyId() {
      return this.currentSurvey.id
    },
  },
  methods: {
    goToSummary() {
      if (this.currentSurveyId) {
        this.$inertia.visit(
          this.$route('survey.user.summary', { id: this.currentSurveyId })
        )
      }
    },
  },
}
</script>
